export default "__VITE_ASSET__KLB$hV7Y__"